module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.a3de2170.ttf";